module.exports = __webpack_public_path__ + "img/thermometer-img6-1.d1b82ed2.png";